module.exports = __webpack_public_path__ + "img/ci.d939dcac.svg";